import { titleCase } from '@/utils'

/**
 * 欄位顯示名：僅放與 titleCase(key) 不符的例外
 * Activity Log 與 DraftChange／發佈 diff 共用
 */
export const FIELD_LABELS = {
  logoUrl: 'Logo',
  faviconUrl: 'Favicon',
  imageUrl: 'Image',
  docs: 'Used In',
  excludedDocs: 'Not Used In',
  allowedIPs: 'IP White List',
  content: 'Description',
  parentSectionId: 'Parent Section',
}

export const getFieldLabel = (key) => {
  if (!key) return ''
  return FIELD_LABELS[key] || titleCase(key)
}
